module.exports = __webpack_public_path__ + "img/step3.6dc65094.png";